import { useAtomValue } from 'jotai';
import {
  cancellationConfirmationModalOpenAtom,
  retentionDiscountOfferModalOpenAtom,
} from '../billingAtoms';

import { getCommerceBillingUiPorts } from '../billing-ui-ports';
import { CancellationConfirmationModal } from './cancellation-confirmation-modal';
import { ClinicianSessionOfferModal } from './clinician-session-offer-modal';
import { RetentionDiscountOfferModal } from './retention-discount-offer-modal';

/** Downgrade retention modals; gated by billing custom-flow flag. */
export function DowngradeRetentionFlowModals() {
  const cancellationOpen = useAtomValue(cancellationConfirmationModalOpenAtom);
  const retentionOpen = useAtomValue(retentionDiscountOfferModalOpenAtom);

  if (!getCommerceBillingUiPorts().isBillingCustomDowngradeFlowsEnabled()) {
    return null;
  }

  return (
    <>
      {cancellationOpen && <CancellationConfirmationModal />}
      {retentionOpen && <RetentionDiscountOfferModal />}
      <ClinicianSessionOfferModal />
    </>
  );
}
